<template>
    <div class="pagination__container">
        <nav aria-label="Page navigation example" class="d-flex justify-content-lg-center">
            <ul class="pagination" v-if="totalPages > 1">
                <li class="page-item previous" :class="{ disabled: isFirstPage }">
                    <button class="page-link" type="button" @click="handleClickPreviousPage" :disabled="isFirstPage">
                        <i class="icon-arrow-left"></i>
                    </button>
                </li>

                <li v-for="page in pages" class="page-item" :class="{ active: isActive(page.content) }">
                    <a v-if="page.breakView" class="page-link">...</a>
                    <a v-else class="page-link" @click="handleClickPage(page.content)" :disabled="page.disabled">
                        {{ page.content }}
                    </a>
                </li>

                <li class="page-item next" :class="{ disabled: isLastPage }">
                    <button class="page-link" type="button" @click="handleClickNextPage" :disabled="isLastPage">
                        <i class="icon-arrow-right"></i>
                    </button>
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
export default {
    name: 'Pagination',
    props: {
        pageRange: {
            type: Number,
            default: 3
        },
        totalPages: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        perPage: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
        labelNext: {
            type: String,
            default: 'next'
        },
        labelPrevious: {
            type: String,
            default: 'previous'
        },
        labelPage: {
            type: String,
            default: 'page'
        },
        labelPagination: {
            type: String,
            default: 'of'
        },
        marginPages: {
            type: Number,
            default: 1
        }
    },
    computed: {
        startPage() {
            // when first page
            if (this.currentPage === 1) {
                return 1;
            }
            // When last page
            if (this.currentPage === this.totalPages) {
                if (this.totalPages > this.pageRange) {
                    return this.totalPages - this.pageRange + 1;
                } else {
                    return this.totalPages - this.currentPage;
                }
            }
            // page between
            return this.currentPage - 1;
        },
        endPage() {
            return Math.min(this.startPage + this.pageRange - 1, this.totalPages);
        },
        pages() {
            let items = {}

            if (this.totalPages <= this.pageRange) {
                for (let index = 0; index < this.totalPages; index++) {
                    let page = {
                        index: index,
                        content: index + 1,
                        selected: index === (this.currentPage - 1)
                    }
                    items[index] = page
                }
            } else {
                const halfPageRange = Math.floor(this.pageRange / 2);

                let setPageItem = index => {
                    let page = {
                        index: index,
                        content: index + 1,
                        selected: index === (this.currentPage - 1)
                    }
                    items[index] = page
                }

                let setBreakView = index => {
                    let breakView = {
                        disabled: true,
                        breakView: true
                    }
                    items[index] = breakView
                }

                // loop thru low margin pages
                for (let i = 0; i < this.marginPages; i++) {
                    setPageItem(i)
                }

                let selectedRangeLow = 0;
                if (this.currentPage - halfPageRange > 0) {
                    selectedRangeLow = this.currentPage - 1 - halfPageRange
                }

                let selectedRangeHigh = selectedRangeLow + this.pageRange - 1;
                if (selectedRangeHigh >= this.totalPages) {
                    selectedRangeHigh = this.totalPages - 1;
                    selectedRangeLow = selectedRangeHigh - this.pageRange + 1;
                }

                for (let i = selectedRangeLow; i <= selectedRangeHigh && i <= this.totalPages - 1; i++) {
                    setPageItem(i)
                }

                if (selectedRangeLow > this.marginPages) {
                    setBreakView(selectedRangeLow - 1)
                }

                if (selectedRangeHigh + 1 < this.totalPages - this.marginPages) {
                    setBreakView(selectedRangeHigh + 1)
                }

                for (let i = this.totalPages - 1; i >= this.totalPages - this.marginPages; i--) {
                    setPageItem(i)
                }
            }

            return items;
        },
        isFirstPage() {
            return this.currentPage === 1;
        },
        isLastPage() {
            return this.currentPage === this.totalPages;
        },
        showCurrentMin() {
            return ((this.currentPage - 1) * this.perPage) + 1;
        },
        showCurrentMax() {
            let max = ((this.showCurrentMin - 1) + this.perPage);
            if (max > this.total) {
                max = this.total;
            }

            return max;
        }
    },
    methods: {
        handleClickPage(page) {
            this.$emit('page-changed', page);
        },
        handleClickFirstPage() {
            this.$emit('page-changed', 1);
        },
        handleClickPreviousPage() {
            this.$emit('page-changed', this.currentPage - 1);
        },
        handleClickNextPage() {
            this.$emit('page-changed', this.currentPage + 1);
        },
        handleClickLastPage() {
            this.$emit('page-changed', this.totalPages);
        },
        isActive(page) {
            return this.currentPage === page;
        }
    }
}
</script>